const BRAND_NAME = 'MAJORDOMO'

export default BRAND_NAME
